// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__0YV77","title":"NotFound_title__emnMV"};